import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default function WatchlistMarketStatusChip({ openCount, closedCount, totalCount }) {
  const openPercent = totalCount > 0 ? (openCount / totalCount) * 100 : 0;
  const pendingCount = Math.max(0, totalCount - openCount - closedCount);
  const label = totalCount === 0
    ? 'No securities'
    : `${openCount} open / ${closedCount} closed${pendingCount ? ` / ${pendingCount} pending` : ''}`;

  return (
    <Tooltip arrow title={totalCount === 0
      ? 'Add securities to see market hours.'
      : `${openCount} of ${totalCount} securities have open markets (${Math.round(openPercent)}%).${pendingCount ? ` Market status is pending for ${pendingCount}.` : ''}`}>
      <Chip
        label={label}
        aria-label={label}
        sx={{
          height: 32,
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'divider',
          color: 'text.primary',
          background: (theme) => {
            if (!totalCount) return theme.palette.action.hover;
            const opacity = theme.palette.mode === 'dark' ? 0.3 : 0.14;
            const green = alpha(theme.palette.success.main, opacity);
            const red = alpha(theme.palette.error.main, opacity);
            return `linear-gradient(90deg, ${green} 0% ${openPercent}%, ${red} ${openPercent}% 100%)`;
          },
          '& .MuiChip-label': {
            px: 1.5,
            fontSize: '0.72rem',
            fontWeight: 650,
            fontVariantNumeric: 'tabular-nums',
            textTransform: 'none',
            letterSpacing: 0,
          },
        }}
      />
    </Tooltip>
  );
}
